import styled from 'styled-components';

export const SummaryContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
`;

export const SummaryMain = styled.div`
  border: 1px solid #e4e4e4;
  padding: 20px;
  margin-right: 2%;
  margin-top: 1%;
  box-shadow: 0px 0px 8px #e4e4e4;
`;

export const SummaryItemMain = styled.div`
  padding: 6px 0;
  font-size: 14px;
  line-height: normal;
  display: flex;
  gap: 0.5rem;
`;

export const SummaryItemLabel = styled.div`
  font-weight: 700;
  line-height: normal;
  display: inline-block;
  width: 90%;
`;

export const TrackerTitle = styled.h4`
  font-weight: 700;
  font-size: 1.1rem;
  margin: 0 0 0.5rem;
`;

export const SummaryItemCount = styled.div`
  flex-shrink: 0;
`;
